// extracted by mini-css-extract-plugin
var _1 = "TypesWindowedSelect_option__470Ac";
var _2 = "TypesWindowedSelect_root__FcqrI";
export { _1 as "option", _2 as "root" }
